module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAARCAYAAADQWvz5AAAABGdBTUEAALGPC/xhBQAAAQJJREFUOBGtkjELQVEYhhGLGO5oo5QMBoMfYDRZlM3MaPIH7MrgD9htZqWYlFIGi1LIYJTR9Xyivnty73HLV0/Od973/TrnOpGIKtd163AFW+0wFFXUu0Rc2yYofaTTMd2wTht9UOvxmoOCgoFa3FDb9Eljz689aiHKnUtsdCGlhRDrM96+nGgC+RDBb1ZHTuR+U0LuLf/2sf82yPzX5JobkA/oV1GEAuS0QQ+6I9TgBFnwqwfCFpow/Jj0oAGbGZiB7co3PJW3t8rvK3CRBbWCBtiGiFfenJxeMlIXCbVgDldIwK8l3gNMoecJ8aTG8q5+rI4nrBsGlGFvGfRAX4Cjs0+lG9nvWmtBFwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/MapToolbar/icon-print-tool.png
// module id = 1476
// module chunks = 0